import React, { useState, useEffect, useRef } from "react";
import { BaseUrl } from "../common/config";
import { http } from "../helper";
import Popup from "../common/popup";
import Select from "react-select";
import { useTranslation } from "react-i18next";

const editProductDetails = (props) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({
    Pid: props.editProddet.productNumber,
    unitofsale: props.editProddet.packageSize || "",
    PrdName: props.editProddet.productDescription || "",
    prodImage: props.editProddet.productImage || "",
    prodnewImage: props.editProddet.productImage || "",
    imageURL: props.editProddet.productImage || "",
    prodSpec: props.editProddet.productSpec || "",
    pdfURL: props.editProddet.productSpec || "",
    PrdIngred: props.editProddet.productIngredient || "",
    PrdAllerg: props.editProddet.productUSP || "",
    Prdtaxcode: props.editProddet.productTaxCode || "",
    Prdgroup: props.editProddet.ProductGroup || "",
    Prdsuitablefor: props.editProddet.SuitableFor || "",
  });
  const [productGroups, setProductGroups] = useState([]);
  const [taxCodes, setTaxCodes] = useState([]);
  const [suitableFors, setSuitableFors] = useState([]);
  const [depots, setDepots] = useState([]);
  const [depotOptions, setDepotOptions] = useState([
    { value: "All", label: t("all_txt") },
  ]);
  const [selectedDepots, setSelectedDepots] = useState([
    { value: "All", label: t("all_txt") },
  ]);
  const taxCodeRef = useRef(null);
  const productGroupRef = useRef(null);
  const suitableForRef = useRef(null);

  useEffect(() => {
    fetchData();
    fetchDepots();
  }, []);

  useEffect(() => {
    if (props.editProddet.activeDepots && depotOptions.length > 0) {
      const activeDepots = props.editProddet.activeDepots
        .toLowerCase()
        .split("/");
      const editselectedDepots = activeDepots
        .map((depot) => {
          const matchedOption = depotOptions.find(
            (option) => option.value.toLowerCase() === depot,
          );
          return matchedOption
            ? { value: matchedOption.value, label: matchedOption.label }
            : null;
        })
        .filter((depot) => depot !== null);
      setSelectedDepots(editselectedDepots);
    }
  }, [depotOptions]);

  useEffect(() => {
    if (!isLoading) {
      const timer = setTimeout(() => {
        if (taxCodeRef.current) {
          taxCodeRef.current.value = formData.Prdtaxcode;
        }
        if (productGroupRef.current) {
          productGroupRef.current.value = formData.Prdgroup;
        }
        if (suitableForRef.current) {
          suitableForRef.current.value = formData.Prdsuitablefor;
        }
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [formData, isLoading]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      var loginDetails = {};
      if (sessionStorage.getItem("authData")) {
        loginDetails = JSON.parse(sessionStorage.getItem("authData"));
      }
      let URL = BaseUrl + `admin/product/masterentries`;
      const response = await http.get(URL);
      if (response.data.success) {
        const { productgroup, taxcode, suitablefor } = response.data.data;
        setProductGroups(productgroup);
        setTaxCodes(taxcode);
        setSuitableFors(suitablefor);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchDepots = async () => {
    setIsLoading(true);
    try {
      var loginDetails = {};
      if (sessionStorage.getItem("authData")) {
        loginDetails = JSON.parse(sessionStorage.getItem("authData"));
      }
      let URL = BaseUrl + `admin/getdepots`;
      const response = await http.get(URL);
      if (response.data.success) {
        let responseData = response.data.data;
        setDepots(responseData);
        const tempDepots = responseData.map((depot) => ({
          value: depot.subDepot,
          label: depot.subDepot,
        }));
        setDepotOptions((prev) => [...prev, ...tempDepots]);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const [errors, setErrors] = useState({});
  const [errorField, setErrorField] = useState(null);

  const handleValue = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    // Clear error message for the corresponding field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleMultiSelectDepots = (selected) => {
    let lastindex = selected.length - 1;
    if (selected.length > 0) {
      if (selected[lastindex].value == "All") {
        setSelectedDepots([{ value: "All", label: t("all_txt") }]);
      } else {
        setSelectedDepots(selected.filter((select) => select.value != "All"));
      }
    } else {
      setSelectedDepots(selected);
    }
  };

  const editSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    const isValid = formvalidation();
    if (isValid) {
      let finalActiveDepots = "";
      if (selectedDepots.some((option) => option.value === "All")) {
        finalActiveDepots = "";
      } else {
        finalActiveDepots = selectedDepots
          .map((option) => option.value)
          .join("/");
      }
      const updatedFormData = {
        ...formData,
        activeDepots: finalActiveDepots,
      };
      props.editProdDetails(updatedFormData);
    } else {
      // Focus on the first field with an error message
      setErrorField(Object.keys(errors)[0]);
    }
  };

  const handleFileChange = (event) => {
    const newPdfFile = event.target.files[0];
    if (newPdfFile) {
      const allowedTypes = ["application/pdf"];
      if (newPdfFile.size > 2 * 1024 * 1024) {
        setErrors({ prodSpec: t("file_size_exceeds_txt") });
        return false;
      } else if (allowedTypes.includes(newPdfFile.type)) {
        setFormData({
          ...formData,
          prodSpec: newPdfFile,
        });
      } else {
        setErrors({ prodSpec: t("only_pdf_allowed_txt") });
        return false;
      }
      const { name, value } = event.target;
      // Clear error message for the corresponding field
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
  };

  const handleImageFileChange = (event) => {
    const newFile = event.target.files[0];
    if (newFile) {
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
      if (newFile.size > 2 * 1024 * 1024) {
        setErrors({ prodImage: t("file_size_exceeds_txt") });
        return false;
      } else if (allowedTypes.includes(newFile.type)) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setFormData({
            ...formData,
            prodnewImage: reader.result,
            prodImage: newFile,
          });
        };
        reader.readAsDataURL(newFile);
      } else {
        setErrors({
          prodImage: t("img_only_allowed_txt"),
        });
        return false;
      }
      const { name, value } = event.target;
      // Clear error message for the corresponding field
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
  };

  const formvalidation = () => {
    const newErrors = {};
    let isValid = true;
    if (formData.PrdName.trim() === "") {
      newErrors.PrdName = t("product_description_required_txt");
      isValid = false;
    }
    if (formData.unitofsale.trim() === "") {
      newErrors.unitofsale = t("unit_of_sale_required_txt");
      isValid = false;
    }
    if (formData.Prdtaxcode.trim() === "") {
      newErrors.Prdtaxcode = t("taxcode_required_txt");
      isValid = false;
    }
    if (formData.Prdgroup.trim() === "") {
      newErrors.Prdgroup = t("product_group_required_txt");
      isValid = false;
    }
    if (formData.Prdsuitablefor.trim() === "") {
      newErrors.Prdsuitablefor = t("suitable_for_required_txt");
      isValid = false;
    }
    if (document.getElementById("prodImage").files.length > 0) {
      const fileInput = document.getElementById("prodImage"); // Assuming 'prodImage' is the ID of your file input element
      const allowedExtensions = ["png", "jpg", "jpeg"];
      if (fileInput.size > 2 * 1024 * 1024) {
        newErrors.prodImage = t("file_size_exceeds_txt");
        isValid = false;
      } else if (!hasExtension(fileInput, allowedExtensions)) {
        newErrors.prodImage = t("img_only_allowed_txt");
        isValid = false;
      }
    }
    setErrors(newErrors);
    return isValid;
  };

  const hasExtension = (fileInput, exts) => {
    const fileName = fileInput.value.toLowerCase();
    const extension = fileName.split(".").pop(); // Get the file extension
    return exts.includes(extension);
  };

  return (
    <Popup
      extClass="order-pop info-poup"
      headMoreTxt={
        <>
          <div className="order-top">
            <div className="head">
              <h4>{t("edit_product_details_txt")}</h4>
            </div>
          </div>
        </>
      }
      bodyMoreTxt={
        isLoading || props.editloading ? (
          <div className="loading-buffer"></div>
        ) : (
          <form
            className="form-field bottom vendor-details"
            onSubmit={(e) => editSubmit(e)}
          >
            <div className="input-field">
              <span className="labeltxt">{t("product_code_txt")}</span>
              <input type="text" name="Pid" value={formData.Pid} readOnly />
            </div>
            <div className="input-field">
              <span className="labeltxt">{t("product_description_txt")}</span>
              <input
                type="text"
                name="PrdName"
                value={formData.PrdName}
                onChange={handleValue}
              />
              {errors.PrdName && (
                <div className="error-msg">{errors.PrdName}</div>
              )}
            </div>
            <div className="input-field col-2">
              <span className="labeltxt">{t("category_txt")}</span>
              <input
                type="text"
                name="categoryId"
                value={
                  (props.editProddet.categoryId === "1"
                    ? t("categories.pizza")
                    :(["10", "13", "11", "12"].includes(props.editProddet.categoryId)
                      ? t("categories.pasta_rice_noodle_sauces")
                      : (props.editProddet.categoryId === "14"
                        ? t("categories.desserts")
                        : "")))
                }
                readOnly
              />
            </div>
            <div className="input-field col-2">
              <span className="labeltxt">{t("tax_code_txt")}</span>
              <select name="Prdtaxcode" ref={taxCodeRef} onChange={handleValue}>
                <option value="">{t("select_txt")}</option>
                {taxCodes.map((code) => (
                  <option key={code._id} value={code.MasterValue}>
                    {code.MasterValue}
                  </option>
                ))}
              </select>
              {errors.Prdtaxcode && (
                <div className="error-msg">{errors.Prdtaxcode}</div>
              )}
            </div>
            <div className="input-field">
              <span className="labeltxt">{t("product_img_txt")}</span>
              <span className="text-note">
                {" "}
                {t("max_upolad_filesize_txt")}
              </span>
              <input
                type="file"
                id="prodImage"
                name="prodImage"
                onChange={handleImageFileChange}
              />
              {errors.prodImage && (
                <div className="color-red">
                  {errors.prodImage}
                  <br />
                  <br />
                </div>
              )}
              {formData.prodnewImage && (
                <img width="100" src={formData.prodnewImage} alt={t("preview_txt")} />
              )}
              <input type="hidden" name="imageURL" value={formData.prodImage} />
            </div>
            <div className="input-field">
              <span className="labeltxt">{t("product_reference_txt")}</span>
              <input
                type="text"
                name="PrdReference"
                value={props.editProddet.ProductReference}
                readOnly
              />
            </div>
            <div className="input-field">
              <span className="labeltxt">{t("usp_allergens_txt")}</span>
              <textarea
                name="PrdAllerg"
                value={formData.PrdAllerg}
                onChange={handleValue}
              />
            </div>
            <div className="input-field">
              <span className="labeltxt">{t("colours_ingredients_txt")}</span>
              <textarea
                name="PrdIngred"
                value={formData.PrdIngred}
                onChange={handleValue}
              />
              {errors.PrdIngred && (
                <div className="error-msg">{errors.PrdIngred}</div>
              )}
            </div>
            <div className="input-field">
              <span className="labeltxt">{t("product_spec_label_txt")}</span>
              <span className="text-note">
                {" "}
                {t("max_upolad_filesize_txt")}
              </span>
              <input
                type="file"
                id="prodSpec"
                name="prodSpec"
                onChange={handleFileChange}
              />
              {errors.prodSpec && (
                <div className="color-red">
                  {errors.prodSpec}
                  <br />
                  <br />
                </div>
              )}
              {formData.pdfURL && (
                <div className="up-data-file">
                  <a href={formData.pdfURL} target="_blank">
                    {formData.pdfURL}
                  </a>
                </div>
              )}
              <input type="hidden" name="pdfURL" value={formData.pdfURL} />
            </div>
            <div className="input-field col-2">
              <span className="labeltxt">{t("pack_size_label_txt")}</span>
              <input
                type="text"
                name="unitofsale"
                value={formData.unitofsale}
                onChange={handleValue}
              />
              {errors.unitofsale && (
                <div className="error-msg">{errors.unitofsale}</div>
              )}
            </div>
            <div className="input-field col-2">
              <span className="labeltxt">{t("product_group_txt")}</span>
              <select
                name="Prdgroup"
                ref={productGroupRef}
                onChange={handleValue}
              >
                <option value="">{t("select_txt")}</option>
                {productGroups.map((group) => (
                  <option key={group._id} value={group.MasterValue}>
                    {group.MasterValue}
                  </option>
                ))}
              </select>
              {errors.Prdgroup && (
                <div className="error-msg">{errors.Prdgroup}</div>
              )}
            </div>
            <div className="input-field col-2">
              <span className="labeltxt">{t("suitable_for_txt")}</span>
              <select
                name="Prdsuitablefor"
                ref={suitableForRef}
                onChange={handleValue}
              >
                <option value="">{t("select_txt")}</option>
                {suitableFors.map((suitable) => (
                  <option key={suitable._id} value={suitable.MasterValue}>
                    {suitable.MasterValue}
                  </option>
                ))}
              </select>
              {errors.Prdsuitablefor && (
                <div className="error-msg">{errors.Prdsuitablefor}</div>
              )}
            </div>
            <div className="input-field">
              <span className="labeltxt">{t("enable_by_depot_txt")}</span>
              <Select
                className="custom-react-select"
                options={depotOptions}
                isMulti
                value={selectedDepots}
                onChange={handleMultiSelectDepots}
                placeholder={t("select_depot_txt")}
              />
            </div>
            <div className="btn-field btn-center">
              <button title={t("submit_txt")} type="submit">{t("submit_txt")}</button>&nbsp;&nbsp;
              <button title={t("cancel_txt")} onClick={(e) => props.popupclose(e, false, "")}>
                {t("cancel_txt")}
              </button>
            </div>
          </form>
        )
      }
      closebtn={
        <>
          <span
            onClick={(e) => props.popupclose(e, false, "")}
            className="close"
          ></span>
        </>
      }
    />
  );
};

export default editProductDetails;
